// src/authConfig.js
export const msalConfig = {
  auth: {
    clientId:              process.env.REACT_APP_AZURE_CLIENT_ID,
    authority:             `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri:           window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation:          "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
  extraScopesToConsent: [
    "https://vault.azure.net/user_impersonation",
    "https://management.azure.com/user_impersonation",
  ],
};

export const kvRequest = (account) => ({
  scopes:  ["https://vault.azure.net/user_impersonation"],
  account,
  forceRefresh: false,
});

export const mgmtRequest = (account) => ({
  scopes:  ["https://management.azure.com/user_impersonation"],
  account,
  forceRefresh: false,
});